export const FETCH_ASSET_STATUS_LIST_END = "FETCH_ASSET_STATUS_LIST_END";
